import React, { useState, useCallback, useRef, createContext, useEffect } from 'react';
import ReactFlow, { Controls, Background, applyEdgeChanges, applyNodeChanges, 
  MiniMap, addEdge, useNodesState, useEdgesState, ReactFlowProvider, updateEdge, Panel, updateNode, useOnSelectionChange,
} from 'reactflow';
// import 'reactflow/dist/style.css';
import { Alert, Box, Button, Collapse, Divider, IconButton, Paper, Input, Typography, Grid, FormControl, Select, MenuItem, InputLabel, useTheme, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText, Tooltip, tooltipClasses } from "@mui/material";
import { styled } from '@mui/material/styles';
import ResizableNodeSelected from './ResizableNodeSelected.jsx';
import ComplexNode from './ComplexNode.jsx';
import OrGate from './OrGate.jsx';
import AndGate from './AndGate.jsx';
import PhysicalSecurityPlan from './DefensiveNodes/PhysicalSecurityPlan.jsx';
import ConfigurationManagementProgram from './DefensiveNodes/ConfigurationManagementPlan.jsx';
import VulnerabilityManagementProgram from './DefensiveNodes/VulnerabilityManagementProgram.jsx';
import Firewall from './DefensiveNodes/Firewall.jsx';
import IntrusionDetectionSystem from './DefensiveNodes/IntrusionDetectionSystem.jsx';
import NetworkMonitoring from './DefensiveNodes/NetworkMonitoring.jsx';
import CounterMeasure from './DefensiveNodes/CounterMeasures.jsx'
import {v4} from 'uuid';
import LaunchIcon from '@mui/icons-material/Launch';
import AttackerObjective from './OtherNodes/objectiveNode.jsx';
import AttackVector from './OtherNodes/attackNodes.jsx';
import Group from './OtherNodes/group.jsx';
import DataGridCustomToolbar from '../../../../components/DataGridCustomToolbar';
import './index.css';

import FloatingEdge from './FloatingEdge';
import FloatingConnectionLine from './FloatingConnectionLine';
import { createNodesAndEdges } from './utils.js';
import Sidebar from './Sidebar.js';
import DownloadButton from './DownloadImage.jsx';
import ContextMenu from './ContextMenu.js';

import useAxiosPrivate from '../../../../hooks/useAxiosPrivate.js';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ResizableObjective from './resizableObjective.jsx';
import ResizableAttackVector from './resizableAttackVector.jsx';
import trustedNetwork from './trustedNetwork.jsx';

import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridEditInputCell,
  GridColDef,
  gridClasses
} from '@mui/x-data-grid';
import WidgetWrapper from '../../../../components/WidgetWrapper.jsx';
import TrustedNetwork from './trustedNetwork.jsx';



export const NodeContext = createContext();


const nodeTypes = {
  resizableNodeSelected: ResizableNodeSelected,
  orgate: OrGate,
  andgate: AndGate,
  physicalsecurityplan: PhysicalSecurityPlan,
  configurationmanagementplan: ConfigurationManagementProgram,
  vulnerabilitymanagementplan: VulnerabilityManagementProgram,
  firewall: Firewall,
  intrusiondetectionsystem: IntrusionDetectionSystem,
  networkmonitoring: NetworkMonitoring,
  attackvector: AttackVector,
  attackerobjective: AttackerObjective,
  resizableObjective: ResizableObjective,
  resizableAttackVector: ResizableAttackVector,
  complexNode: ComplexNode,
  countermeasure: CounterMeasure,
  group: Group,
  trustedNetwork: TrustedNetwork
};

const edgeTypes = {
  floating: FloatingEdge,
};


const ZoneCreator = () => {

  const { palette } = useTheme();
  const primaryLight = palette.primary.light;
  const primaryDark = palette.primary.dark;
  const main = palette.neutral.main;
  const medium = palette.neutral.medium;

  const theme = useTheme();

  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [zoneScore, setZoneScore] = useState(0);
  const [totalZoneAttackSurface, setTotalZoneAttackSurface] = useState(0);
  const [screenWidgets, setScreenWidgets] = useState(6);

  const reactFlowWrapper = useRef(null);
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [open, setOpen] = useState(false);
  const [openToDelete, setOpenToDelete] = useState(false);
  const [openSaveAs, setOpenSaveAs] = useState(false);
  const [attackTreeName, setAttackTreeName] = useState("");
  const [allAssessmentAttackTrees, setAllAssessmentAttackTrees] = useState([]);
  const [menu, setMenu] = useState(null);
  const ref = useRef(null);
  const [target, setTarget] = useState(null);
  const dragRef = useRef(null);

  const { assessmentID } = useParams();
  const axiosPrivate = useAxiosPrivate();

  const navigate = useNavigate();
  const location = useLocation();

  const [allZoneData, setAllZoneData] = useState();
  const [openInstructions, setOpenInstructions] = useState(true);
  const [tempSegmentationType, setTempSegmentationType] = useState("test");
  const [displayNode, setDisplayNode] = useState();
  const [displayNodeAssets, setDisplayNodeAssets] = useState();
  const [techniquesPerZone, setTechniquesPerZone] = useState();
  const [displayNodeTypes, setDisplayNodeTypes] = useState();

  const [questionIndex, setQuestionIndex] = useState(0);
  //  const [columns, setColumns] = useState();

  const assetTypesList = [ "Application Server", "Control Server", "Data Gateway", "Data Historian", "Field IO", "Human-Machine Interface", "Intelligent Electronic Device", "Jump Host", "Programmable Logic Controller", "Router", "Remote Terminal Unit", "Safety Controller", "Virtual Private Network", "Workstations" ];

  const allTechniques = [
    "T0800",
"T0830",
"T0878",
"T0802",
"T0895",
"T0803",
"T0804",
"T0805",
"T0806",
"T0892",
"T0858",
"T0807",
"T0885",
"T0884",
"T0879",
"T0809",
"T0811",
"T0893",
"T0812",
"T0813",
"T0814",
"T0815",
"T0868",
"T0816",
"T0817",
"T0871",
"T0819",
"T0820",
"T0890",
"T0866",
"T0822",
"T0823",
"T0891",
"T0874",
"T0877",
"T0872",
"T0883",
"T0867",
"T0826",
"T0827",
"T0828",
"T0837",
"T0880",
"T0829",
"T0835",
"T0831",
"T0832",
"T0849",
"T0838",
"T0821",
"T0836",
"T0889",
"T0839",
"T0801",
"T0834",
"T0840",
"T0842",
"T0861",
"T0843",
"T0845",
"T0873",
"T0886",
"T0846",
"T0888",
"T0847",
"T0848",
"T0851",
"T0852",
"T0853",
"T0881",
"T0865",
"T0856",
"T0869",
"T0862",
"T0894",
"T0857",
"T0882",
"T0864",
"T0855",
"T0863",
"T0859",
"T0860",
"T0887"
  ];

  const allTechniquesMaxScore = [
    44, 
56, 
24, 
24, 
12, 
28, 
28, 
28, 
28, 
20, 
40, 
20, 
20, 
20, 
24, 
28, 
36, 
32, 
16, 
24, 
16, 
24, 
36, 
48, 
32, 
20, 
32, 
20, 
20, 
40, 
40, 
20, 
12, 
12, 
8, 
20, 
12, 
24, 
12, 
24, 
8, 
8, 
12, 
16, 
8, 
16, 
16, 
32, 
44, 
28, 
32, 
32, 
64, 
12, 
6, 
8, 
32, 
40, 
56, 
40, 
20, 
60, 
16, 
20, 
28, 
36, 
12, 
12, 
32, 
36, 
32, 
32, 
16, 
24, 
16, 
68, 
16, 
28, 
36, 
44, 
48, 
28, 
12, 
  ]

  const techniquesPerAsset2 = 
    {
      applicationServer: [
        "T0807",
        "T0809",
        "T0812",
        "T0816",
        "T0819",
        "T0820",
        "T0822",
        "T0823",
        "T0830",
        "T0834",
        "T0840",
        "T0842",
        "T0846",
        "T0847",
        "T0849",
        "T0851",
        "T0853",
        "T0859",
        "T0862",
        "T0866",
        "T0867",
        "T0869",
        "T0872",
        "T0874",
        "T0881",
        "T0883",
        "T0884",
        "T0885",
        "T0886",
        "T0888",
        "T0890",
        "T0892",
        "T0893",
        "T0894",
        "T0895",
      ],
      dataGateway: [
        "T0800",
        "T0830",
        "T0878",
        "T0804",
        "T0805",
        "T0892",
        "T0807",
        "T0885",
        "T0884",
        "T0809",
        "T0812",
        "T0814",
        "T0816",
        "T0871",
        "T0820",
        "T0890",
        "T0866",
        "T0822",
        "T0823",
        "T0874",
        "T0872",
        "T0849",
        "T0838",
        "T0801",
        "T0834",
        "T0840",
        "T0842",
        "T0861",
        "T0886",
        "T0846",
        "T0888",
        "T0847",
        "T0848",
        "T0851",
        "T0853",
        "T0881",
        "T0856",
        "T0869",
        "T0862",
        "T0857",
        "T0859"
      ],

      controlServer: [
        "T0801",
        "T0802",
        "T0803",
        "T0804",
        "T0805",
        "T0806",
        "T0807",
        "T0809",
        "T0811",
        "T0812",
        "T0814",
        "T0816",
        "T0820",
        "T0823",
        "T0830",
        "T0834",
        "T0840",
        "T0842",
        "T0846",
        "T0847",
        "T0848",
        "T0849",
        "T0851",
        "T0853",
        "T0855",
        "T0856",
        "T0859",
        "T0861",
        "T0862",
        "T0866",
        "T0867",
        "T0869",
        "T0872",
        "T0874",
        "T0878",
        "T0881",
        "T0884",
        "T0885",
        "T0886",
        "T0888",
        "T0890",
        "T0892",
        "T0893",
        "T0894",
        "T0895"
      ],
      dataHistorian: [
        "T0830",
        "T0878",
        "T0802",
        "T0895",
        "T0892",
        "T0807",
        "T0885",
        "T0884",
        "T0809",
        "T0811",
        "T0893",
        "T0812",
        "T0814",
        "T0816",
        "T0820",
        "T0890",
        "T0866",
        "T0822",
        "T0823",
        "T0874",
        "T0872",
        "T0849",
        "T0801",
        "T0834",
        "T0840",
        "T0842",
        "T0861",
        "T0886",
        "T0846",
        "T0888",
        "T0847",
        "T0848",
        "T0851",
        "T0853",
        "T0881",
        "T0869",
        "T0862",
        "T0894",
        "T0859"
      ],

      fieldio: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0830", 
        "T0834", 
        "T0847", 
        "T0851", 
        "T0859", 
        "T0860", 
        "T0862", 
        "T0867", 
        "T0871", 
        "T0884", 
        "T0885", 
        "T0887", 
        "T0888", 
        "T0891"
      ],

      hmi: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0807", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0823", 
        "T0830", 
        "T0834", 
        "T0838", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0849", 
        "T0851", 
        "T0852", 
        "T0853", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0863", 
        "T0866", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0878", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0886", 
        "T0888", 
        "T0890", 
        "T0892", 
        "T0893", 
        "T0894", 
        "T0895"
      ],

      ied: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0830", 
        "T0834", 
        "T0836", 
        "T0838", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0851", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0866", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0878", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0888", 
        "T0890", 
        "T0892"
      ],

      jumpHost: [
        "T0805", 
        "T0807", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0822", 
        "T0823", 
        "T0830", 
        "T0834", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0849", 
        "T0851", 
        "T0852", 
        "T0853", 
        "T0859", 
        "T0862", 
        "T0863", 
        "T0865", 
        "T0866", 
        "T0867", 
        "T0869", 
        "T0872", 
        "T0874", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0886", 
        "T0888", 
        "T0890", 
        "T0892", 
        "T0893", 
        "T0894", 
        "T0895"
      ],

      plc: [
        "T0800", 
        "T0801", 
        "T0802", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0821", 
        "T0830", 
        "T0834", 
        "T0835", 
        "T0836", 
        "T0838", 
        "T0839", 
        "T0840", 
        "T0842", 
        "T0843", 
        "T0845", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0851", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0858", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0866", 
        "T0868", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0877", 
        "T0878", 
        "T0884", 
        "T0885", 
        "T0888", 
        "T0889", 
        "T0890", 
        "T0892"
      ],

      rtu: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0830", 
        "T0834", 
        "T0836", 
        "T0838", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0866", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0878", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0888", 
        "T0892"
      ],

      routers: [
        "T0809", 
        "T0812", 
        "T0816", 
        "T0820", 
        "T0822", 
        "T0830", 
        "T0866", 
        "T0874", 
        "T0884", 
        "T0885", 
        "T0890", 
        "T0892"
      ],

      safetyController: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0821", 
        "T0830", 
        "T0834", 
        "T0835", 
        "T0838", 
        "T0839", 
        "T0840", 
        "T0842", 
        "T0843", 
        "T0845", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0851", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0858", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0866", 
        "T0868", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0877", 
        "T0878", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0888", 
        "T0889", 
        "T0890", 
        "T0892"
      ],

      vpnAsset: [
        "T0805", 
        "T0809", 
        "T0812", 
        "T0816", 
        "T0819", 
        "T0820", 
        "T0822", 
        "T0830", 
        "T0834", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0851", 
        "T0857", 
        "T0859", 
        "T0862", 
        "T0866", 
        "T0867", 
        "T0869", 
        "T0872", 
        "T0874", 
        "T0881", 
        "T0883", 
        "T0884", 
        "T0885", 
        "T0886", 
        "T0888", 
        "T0890", 
        "T0892"
      ],

      workstations: [
        "T0805", 
        "T0807", 
        "T0809", 
        "T0812", 
        "T0816", 
        "T0817", 
        "T0819", 
        "T0820", 
        "T0823", 
        "T0830", 
        "T0834", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0849", 
        "T0851", 
        "T0852", 
        "T0853", 
        "T0859", 
        "T0860", 
        "T0862", 
        "T0863", 
        "T0864", 
        "T0865", 
        "T0866", 
        "T0867", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0873", 
        "T0874", 
        "T0881", 
        "T0883", 
        "T0884", 
        "T0885", 
        "T0887", 
        "T0888", 
        "T0890", 
        "T0892", 
        "T0893", 
        "T0894", 
        "T0895"
      ]
    }


  const handleChange = async (event) => {
    setAttackTreeName(event.target.value);
    try {
      const response = await axiosPrivate.get(`/zones/${assessmentID}/${event.target.value}`, {
          withCredentials: true
      });
      const data = await response.data;
      // setAllAssessmentAttackTrees(data);

      setNodes(data[0]?.graphObjects?.nodes);
      setEdges(data[0]?.graphObjects?.edges);

    } catch (err) {
      alert("Login Expired.");
      console.error(err);
      // navigate('/login', { state: { from: location }, replace: true });
    }
  };


  const onEdgeUpdate = useCallback(
    (oldEdge, newConnection) => setEdges((els) => updateEdge(oldEdge, newConnection, els)),
    []
  );

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    [setNodes],
  );
  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    [setEdges],
  );

   const getId = () => {
    let id = v4();
    return (
      `dndnode_${id}`
    )
  }

  const boundaryProtectionNodeWidth = 125;
  const boundaryProgectionNodeHeight = 50;
  const boundaryProtectionNodeColor = 'rgba(0, 0, 0, 1)';
  const assetTypeNodeWidth = 150;
  const assetTypeNodeHeight = 50;
  const assetTypeNodeColor = 'rgba(103, 72, 152, 0.9)';

  const handleBuildZoneNodes = async (data) => {

    let tempNodes = [];
    // console.log(data);
    // console.log(JSON.parse(data[0].zoneData));
    for (let i = 0; i < data.length; i++) {
      let counterX = 0;
      let counterY = 150;
      let assetCounterX = 0;
      let assetCounterY = 200;
      let totalCount = 0;
      // setTempSegmentationType("");
      let tempZoneData = JSON.parse(data[i].zoneData);
      // let tempSegTypeLIST = ["net1", "net2", "net3"];
      let tempSegTypeLIST =[];
      let tempSegType = ""
      if (tempZoneData?.segmentationType?.physicalNetwork) {
        // setTempSegmentationType(tempSegmentationType + "Physical Network ");
        tempSegType = tempSegType + "Physical Network "
        tempSegTypeLIST.push("Physical Network ");
      }
      if (tempZoneData?.segmentationType?.vpn) {
        // setTempSegmentationType(tempSegmentationType + "VPN ");
        tempSegType = tempSegType + "VPN ";
        tempSegTypeLIST.push("VPN ");
      }
      if (tempZoneData?.segmentationType?.vlan) {
        tempSegType = tempSegType + "VLAN ";
        tempSegTypeLIST.push("VLAN ");
      }
      if (tempZoneData?.segmentationType?.sdn) {
        tempSegType = tempSegType + "SDN ";
        tempSegTypeLIST.push("SDN ");
      }
      if (tempZoneData?.segmentationType?.subnetting) {
        tempSegType = tempSegType + "Subnetting ";
        tempSegTypeLIST.push("Subnetting ");
      };
        if (tempZoneData?.segmentationType?.other) {
        tempSegType = tempSegType + "Other ";
        tempSegTypeLIST.push("Other ");
      };
      // console.log(tempZoneData.segmentationType.physicalNetwork);
        tempNodes.push(
          {
            id: data[i]._id, 
            position: {x:(i*500+((counterX+i)*20)), y:(0)}, 
            data: {label: data[i].zoneName, description: tempZoneData?.zoneDescription, segmentationType: tempSegTypeLIST }, 
            style: {
              backgroundColor: 'rgba(19, 150, 155, 0.2)',
              width: 500, 
              height: 500,
              fontSize: '1em',
            }, 
            type: 'group' 
          }
      );
      // Boundary Protection Nodes.
      if (tempZoneData?.boundaryProtection?.firewall) {
          tempNodes.push(
            {
              id: `fw${data[i]._id}`,
              position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
              data: {label: "Firewall"},
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: boundaryProtectionNodeColor,
                width:  boundaryProtectionNodeWidth,
                height: boundaryProgectionNodeHeight,
                color: 'rgba(255, 255, 255, 1)'
              },
            }
          );
          counterX = counterX + 1;
        };

      if (tempZoneData.boundaryProtection.router) {
          tempNodes.push(
            {
              id: `rtr${data[i]._id}`,
              position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
              data: {label: "Router"},
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: boundaryProtectionNodeColor,
                width: boundaryProtectionNodeWidth, 
                height: boundaryProgectionNodeHeight,
                color: 'rgba(255, 255, 255, 1)'
              }, 
            }
          );
          counterX = counterX + 1;
        };

        if (tempZoneData.boundaryProtection.switch) {
          tempNodes.push(
            {
              id: `sw${data[i]._id}`,
              position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
              data: {label: "Switch (Layer 3)"},
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: boundaryProtectionNodeColor,
                width: boundaryProtectionNodeWidth, 
                height: boundaryProgectionNodeHeight,
                color: 'rgba(255, 255, 255, 1)'
              }, 
            }
          );
          counterX = counterX + 1;
           if (counterX > 2) {
            counterX = 0;
            counterY = 135;
          }
        };

        if (tempZoneData.boundaryProtection.dataDiode) {
          tempNodes.push(
            {
              id: `diode${data[i]._id}`,
              position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
              data: {label: "Data Diode"},
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: boundaryProtectionNodeColor,
                width: boundaryProtectionNodeWidth, 
                height: boundaryProgectionNodeHeight,
                color: 'rgba(255, 255, 255, 1)'
              }, 
            }
          );
          counterX = counterX + 1;
          if (counterX > 2) {
            counterX = 0;
            counterY = 135;
          }
        };

         if (tempZoneData.boundaryProtection.boundaryOther) {
          tempNodes.push(
            {
              id: `other${data[i]._id}`,
              position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
              data: {label: "Other"},
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: boundaryProtectionNodeColor,
                width: boundaryProtectionNodeWidth, 
                height: boundaryProgectionNodeHeight,
                color: 'rgba(255, 255, 255, 1)'
              }, 
            }
          );
          counterX = counterX + 1;
        };


        // Asset Types
         if (tempZoneData.assetTypes.applicationServer) {
          tempNodes.push(
            {
              id: `appsver${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `Application Server (${tempZoneData?.assetTypes?.applicationServerQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
        };
        if (tempZoneData.assetTypes.controlServer) {
          tempNodes.push(
            {
              id: `cntlsvr${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `Control Server (${tempZoneData.assetTypes.controlServerQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
        };
        if (tempZoneData.assetTypes.dataGateway) {
          tempNodes.push(
            {
              id: `dataGwy${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `Data Gateway (${tempZoneData?.assetTypes?.dataGatewayQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              default:
           }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.dataHistorian) {
          tempNodes.push(
            {
              id: `dataHstn${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `Data Historian (${tempZoneData.assetTypes.dataHistorianQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
            
          }
        };
          if (tempZoneData.assetTypes.fieldio) {
          tempNodes.push(
            {
              id: `fieldio${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `FieldIO (${tempZoneData.assetTypes.fieldioQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.hmi) {
          tempNodes.push(
            {
              id: `hmi${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `HMI (${tempZoneData.assetTypes.hmiQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.ied) {
          tempNodes.push(
            {
              id: `ied${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `IED (${tempZoneData.assetTypes.iedQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.jumpHost) {
          tempNodes.push(
            {
              id: `jmphst${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `Jump Host (${tempZoneData.assetTypes.jumpHostQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.plc) {
          tempNodes.push(
            {
              id: `plc${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `PLC (${tempZoneData.assetTypes.plcQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
               case 12:
                assetCounterY = 400;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.rtu) {
          tempNodes.push(
            {
              id: `rtu${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `RTU (${tempZoneData.assetTypes.rtuQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              case 12:
                assetCounterY = 400;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.routers) {
          tempNodes.push(
            {
              id: `rtrs${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `Routers (${tempZoneData.assetTypes.routersQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              case 12:
                assetCounterY = 400;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.safetyController) {
          tempNodes.push(
            {
              id: `safetyCntl${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `Safety Controller (${tempZoneData.assetTypes.safetyControllerQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              case 12:
                assetCounterY = 400;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.vpnAsset) {
          tempNodes.push(
            {
              id: `vpnasset${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `VPN (${tempZoneData.assetTypes.vpnAssetQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 300;
                break;
              case 9:
                assetCounterY = 350;
                break;
              case 12:
                assetCounterY = 350;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };
        if (tempZoneData.assetTypes.workstations) {
          tempNodes.push(
            {
              id: `wkstn${data[i]._id}`,
              position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
              data: {label: `Workstations (${tempZoneData.assetTypes.workstationsQuantity})` },
              type: 'default',
              parentId: data[i]._id,
              extent: 'parent',
              style: {
                backgroundColor: assetTypeNodeColor,
                width: assetTypeNodeWidth, 
                height: 40,
              }, 
            }
          );
          assetCounterX = assetCounterX + 1;
          totalCount = totalCount + 1;
          switch (totalCount) {
              case 3:
                assetCounterY = 250;
                break;
              case 6:
                assetCounterY = 250;
                break;
              case 19:
                assetCounterY = 300;
                break;
              case 12:
                assetCounterY = 350;
                break;
              default:
            }
          if (assetCounterX > 2) {
            assetCounterX = 0;
          }
        };


    }
    setNodes(tempNodes);
  };

  // Get zones for this assessment. 
    const getZones = async () => {
      try {
        const response = await axiosPrivate.get(`/zones/${assessmentID}`, {
            withCredentials: true
        });
        const data = await response.data;
        setAllZoneData(data);
        handleBuildZoneNodes(data);
        // console.log(data);
      } catch (err) {
        // alert("Login Expired.");
        console.error(err);
        // navigate('/login', { state: { from: location }, replace: true });
      }
    };

  const getAssessmentAttackTrees = async () => {
    try {
      const response = await axiosPrivate.get(`/zones/graphs/${assessmentID}`, {
          withCredentials: true
      });
      const data = await response.data;
      setAllAssessmentAttackTrees(data);
  
      if (allAssessmentAttackTrees === null) {
          return;
      }
    } catch (err) {
      alert("Login Expired.");
      console.error(err);
      // navigate('/login', { state: { from: location }, replace: true });
    }
  };
  
    useEffect(() => {
      // getAssessmentAttackTrees();
      getZones();
      }, []);  // eslint-disable-line react-hooks/exhaustive-deps
  

  const rfStyle = {
    // backgroundColor: main,
    backgroundColor: theme.palette.background.alt,
    border: 'solid 1px'
  };

  const defaultViewport = { x: 0, y: 0, zoom: 2 };

  const minimapStyle = {
    height: 300,
    width: 300
  };

  // const onConnect = useCallback((params) => setEdges((eds) => addEdge({...params, type: 'floating', animated: false, style: {stroke: '#000', background: '#000', strokeWidth: '2' }}, eds)), [setEdges]);

  const onConnect = useCallback((params) => setEdges((eds) => addEdge({...params, type: 'step', animated: false, style: {stroke: '#000', background: '#000', strokeWidth: '2' }}, eds)), [setEdges]);

  const onNodeDragStart = (event, node) => {
    dragRef.current = node;
  };

  const onNodeDrag = (event, node) => {
    const centerX = node.position.x + node.width / 2;
    const centerY = node.position.y + node.height / 2;

    const targetNode = nodes.find(
      (n) =>
        centerX > n.position.x &&
        centerX < n.position.x + n.width &&
        centerY > n.position.y &&
        centerY < n.position.y + n.height &&
        n.id !== node.id // this is needed, otherwise we would always find the dragged node
    );

    setTarget(targetNode);
  };

  const onNodeDragStop = (event, node) => {
    // if (target?.type === 'group' ) {
    //   const index = nodes.indexOf((nds) => nds.id === target.id);
    //   console.log('Index of Target is:');
    //   console.log(index);
    //   nodes.unshift(nodes.splice(index, 1)[0]);
      // node.parentId = target?.id;
      // node.extent = 'parent';
      // const nodeToUpdate = nodes.find((nds) => nds.id === node.id);
      // console.log(nodeToUpdate);
      // Object.assign(nodeToUpdate, node);
    // } else {
    //   return;
    // }
    for (let i=0; i < nodes.length; i++) { 
      // const index = nodes.find((nds) => nds.type === 'group');
      if (nodes[i].type === 'group') {
        // const nodeToUpdate = nodes.find((nds) => nds.id === nodes[i].id);;
        nodes.unshift(nodes.splice(i, 1)[0]);
        // console.log(nodeToUpdate);
        // tempList.push(nodeToUpdate);
      }
    }
    // console.log(nodes);
    

    setTarget(null);
    dragRef.current = null;
    // console.log(nodes);
    setNodes(nodes);
  }

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();


      const type = event.dataTransfer.getData('application/reactflow');
      const title = event.dataTransfer.getData('title');
      const color = event.dataTransfer.getData('color');

      // check if the dropped element is valid
      if (typeof type === 'undefined' || !type) {
        return;
      }

      // reactFlowInstance.project was renamed to reactFlowInstance.screenToFlowPosition
      // and you don't need to subtract the reactFlowBounds.left/top anymore
      // details: https://reactflow.dev/whats-new/2023-11-10
      const position = reactFlowInstance.screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      });

      const centerX = position.x + 50;
      const centerY = position.y + 50;

      const targetNode = nodes.find(
        (n) => 
        centerX > n.position.x && 
        centerX < n.position.x + n.width &&
        centerY > n.position.y &&
        centerY < n.position.y + n.height
    );

    if (type === 'resizableNodeSelected') { 
    const newNode = {
      id: getId(),
      type,
      position,
      data: { label: 'Enter Description' },
      dragHandle: '.custom-drag-handle'
    };

    setNodes((nds) => nds.concat(newNode));

  } else if (type === 'resizableObjective') {
    const newNode = {
      id: getId(),
      type,
      position,
      data: { label: 'Enter Description' },
      dragHandle: '.custom-drag-handle'
    }; 

    setNodes((nds) => nds.concat(newNode));

  } else if (type === 'resizableAttackVector') {
    const newNode = {
      id: getId(),
      type,
      position,
      data: { label: 'Enter Description' },
      dragHandle: '.custom-drag-handle'
    }; 

    setNodes((nds) => nds.concat(newNode));
  } else if (type === 'group') {
    const newNode = [{
      id: getId(),
      type,
      position,
      data: { label: 'Enter Description' },
      // dragHandle: '.custom-drag-handle'
    }]; 
    setNodes((nds) => newNode.concat(nds));
   
    // setNodes((nds) => nds.concat(newNode));
    // setNodes(nodes);
  } else {
    const newNode = {
      id: getId(),
      type,
      position,
      data: { label: `${type} node`, title: `${title}`, color: `${color}`  },
    };
    setNodes((nds) => nds.concat(newNode));
  }  
    },
    [reactFlowInstance],
  );

  const onRestore = useCallback(() => {
    const restoreFlow = async () => {
      const flow = JSON.parse(localStorage.getItem(attackTreeName));

      if (flow) {
        const { x = 0, y = 0, zoom = 1 } = flow.viewport;
        setNodes(flow.nodes || []);
        setEdges(flow.edges || []);
      }
    };

    restoreFlow();
  }, [setNodes]);

  const onStore = useCallback(() => {
    if (reactFlowInstance) {
      const flow = reactFlowInstance.toObject();
      localStorage.setItem(attackTreeName, JSON.stringify(flow));
    }
  }, [reactFlowInstance]);

  const onSave = async () => {
    if (reactFlowInstance) {
      const flow = reactFlowInstance.toObject();
      // console.log(flow);
      // localStorage.setItem(flowKey, JSON.stringify(flow));
      if (typeof attackTreeName === 'undefined' || !attackTreeName) {
        setOpen(true);
        return;
      } else {
        try {
          const response = await axiosPrivate.patch(`/graph/zones/${assessmentID}/${attackTreeName}`,
          { "graphObjects": flow },    
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
          }
        );
        const data = await response.data;
        // console.log(response.data);
        
        } catch (err) {
            if (!err?.response) {
                console.log('No Server Response');
            } else {
                console.log('Action Failed')
            }
        }
      }
    }
    setOpen(false);
  };

  const handleCreateRecord = async () => {
    let attackerObjective = attackTreeName;
    let graphObjects = {};
    try {

        const response = await axiosPrivate.post(`/graph/new`,
            JSON.stringify({ assessmentID, attackerObjective, graphObjects }),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            }
        );
        onSave();
        // Axios provides responses in JSON by default. The response JSON is always named 'data'. 
        // The console log commands below allow you to see the responses from Axios for the response.  
        // navigate(from, { replace: true });
    } catch (err) {
        if (!err?.response) {
            console.log('No Server Response');
        } else {
            console.log('Action Failed')
        }
    }
};

const handleNo = () => {
  setOpen(false);
};

const handleYes = async () => {
  for (let i=0; i<allAssessmentAttackTrees.length+1; i++) {
    if (attackTreeName.trim() === allAssessmentAttackTrees[i]) {
      alert("Names must be unique");
      console.log("Match Found");
      return;
    } 
  }
  setNodes([]);
  const newFile = await handleCreateRecord();
  getAssessmentAttackTrees();
  setOpen(false);
};

const handleNoSaveAs = () => {
  setOpenSaveAs(false);
}

const handleSaveAs = async () => {
  for (let i=0; i<allAssessmentAttackTrees.length+1; i++) {
    if (attackTreeName.trim() === allAssessmentAttackTrees[i]) {
      alert("Names must be unique");
      console.log("Match Found");
      return;
    } 
  }
  const newFile = await handleCreateRecord();
  getAssessmentAttackTrees();
  setOpenSaveAs(false);
};

const handleDeleteAttackTree = async () => {
  try {
      const response = await axiosPrivate.delete(`/zones/${assessmentID}/${attackTreeName}`, {
            withCredentials: true
        }
    );
      if (response.data.success) {
          alert(response.data.msg);
      }
  } catch (err) {
      console.error(err);
  }
  setOpenToDelete(false);
  setNodes([]);
  getAssessmentAttackTrees();
  };

  const handleClickOpen = () => {
    setOpenToDelete(true);
  };

  const onSelectedContextMenu = useCallback(
    (event, selected) => {
      // Prevent native context menu from showing
      event.preventDefault();
      console.log("FROM ON SELECTED CONTEXT MENU");
      console.log(event);
     
      // Calculate position of the context menu. We want to make sure it
      // doesn't get positioned off-screen.
      // const pane = ref.current.getBoundingClientRect();
      setMenu({
        // position: selected[0].position,
        // top: event.clientY - 300,
        // left: event.clientX - 200,
        selected: selected,
        // top: event.clientY < pane.height - 200 && event.clientY,
        // left: event.clientX < pane.width - 200 && event.clientX,
        // right: event.clientX >= pane.width - 200 && pane.width - event.clientX,
        // bottom: event.clientY >= pane.height - 200 && pane.height - event.clientY,
      });
    },
    [setMenu],
  );

  const onNodeContextMenu = useCallback(
    (event, node) => {
      // Prevent native context menu from showing
      event.preventDefault();
      console.log(event.clientY);
      console.log(event.clientX);
      // Calculate position of the context menu. We want to make sure it
      // doesn't get positioned off-screen.
      const pane = ref.current.getBoundingClientRect();
      console.log(pane);
      setMenu({
        id: node.id,
        top: event.clientY - 300,
        left: event.clientX - 200,
        // top: event.clientY < pane.height - 200 && event.clientY,
        // left: event.clientX < pane.width - 200 && event.clientX,
        // right: event.clientX >= pane.width - 200 && pane.width - event.clientX,
        // bottom: event.clientY >= pane.height - 200 && pane.height - event.clientY,
      });
    },
    [setMenu],
  );

  // Close the context menu if it's open whenever the window is clicked.
  const onPaneClick = useCallback(() => setMenu(null), [setMenu]);
  
  const onNodeClick = useCallback(
    (event, node) => {
      // Prevent native context menu from showing
      event.preventDefault();
      // console.log(node);
      // setDisplayNode(node);
      // console.log(allZoneData)
      
      for (let zone in allZoneData) {
        if (node.id === allZoneData[zone]._id) {
          setDisplayNode(allZoneData[zone].zoneName);

          let count = JSON.parse(allZoneData[zone].zoneData).assetTypes;
          let tempColumns = [
            {
              field: "technique",
              headerName: "Attack Technique",
              flex: 3,
              renderCell: (params) =>  (
                <CustomWidthTooltip title={<p style={{ fontSize: "20px" }}>{techniqueDescriptions[0]}</p>} >
                  <span>{params.value}</span>
                </CustomWidthTooltip>
              )
            },
          ]

        if (count?.applicationServer===true) {
          tempColumns.push(
            {
              field: "applicationServer",
              headerName: "Application Server",
              flex: 2,
            },
          )}
        if (count?.controlServer===true) {
          tempColumns.push(
            {
              field: "controlServer",
              headerName: "Control Server",
              flex: 2,
           },
          )
        }
        if (count?.dataGateway===true) {
          tempColumns.push(
            {
              field: "dataGateway",
              headerName: "Data Gateway",
              flex: 2,
            },
          )
        }
        if (count?.dataHistorian===true) {
          tempColumns.push(
            {
              field: "dataHistorian",
              headerName: "Data Historian",
              flex: 2,
            },
          )
        }
        if (count?.fieldio===true) {
          tempColumns.push(
             {
              field: "fieldio",
              headerName: "Field IO",
              flex: 2,
            },
          )
        }
        if (count?.hmi===true) {
          tempColumns.push(
            {
              field: "hmi",
              headerName: "HMI",
              flex: 2,
            },
          )
        }
        if (count?.ied===true) {
          tempColumns.push(
            {
              field: "ied",
              headerName: "IED",
              flex: 2,
           },
          )
        }
        if (count?.jumpHost===true) {
          tempColumns.push(
            {
              field: "jumpHost",
              headerName: "Jump Host",
              flex: 2,
           },
          )
        }
        if (count?.plc===true) {
          tempColumns.push(
            {
              field: "plc",
              headerName: "PLC",
              flex: 2,
            },
          )
        }
        if (count?.routers===true) {
          tempColumns.push(
            {
              field: "routers",
              headerName: "Routers",
              flex: 2,
            },
          )
        }
        if (count?.rtu===true) {
          tempColumns.push(
             {
              field: "rtu",
              headerName: "RTU",
              flex: 2,
            },
          )
        }
        if (count?.safetyController===true) {
          tempColumns.push(
            {
              field: "safetyController",
              headerName: "Safety Controller",
              flex: 2,
            },
          )
        }
        if (count?.vpnAsset===true) {
          tempColumns.push(
            {
              field: "vpnAsset",
              headerName: "VPN",
              flex: 2,
            },
          )
        }
        if (count?.workstations===true) {
          tempColumns.push(
             {
              field: "workstations",
              headerName: "Workstations",
              flex: 2,
            },
          )
        }
        tempColumns.push(
             {
              field: "score",
              headerName: "Score",
              flex: 2,
            },
          )

          setRows([]);
          // console.log(tempColumns);
          
          let tempArray = [];
          if (count?.applicationServer===true && typeof(count?.applicationServerQuantity) === 'string') {tempArray.push(Number(count?.applicationServerQuantity))}
          if (count?.controlServer===true && typeof(count?.controlServerQuantity) === 'string') {tempArray.push(Number(count?.controlServerQuantity))}
          if (count?.dataGateway===true && typeof(count?.dataGatewayQuantity) === 'string') {tempArray.push(Number(count?.dataGatewayQuantity))}
          if (count?.dataHistorian===true && typeof(count?.dataHistorianQuantity) === 'string') {tempArray.push(Number(count?.dataHistorianQuantity))}
          if (count?.fieldio===true && typeof(count?.fieldioQuantity) === 'string') {tempArray.push(Number(count?.fieldioQuantity))}
          if (count?.hmi===true && typeof(count?.hmiQuantity) === 'string') {tempArray.push(Number(count?.hmiQuantity))}
          if (count?.ied===true && typeof(count?.iedQuantity) === 'string') {tempArray.push(Number(count?.iedQuantity))}
          if (count?.jumpHost===true && typeof(count?.jumpHostQuantity) === 'string') {tempArray.push(Number(count?.jumpHostQuantity))}
          if (count?.plc===true && typeof(count?.plcQuantity) === 'string') {tempArray.push(Number(count?.plcQuantity))}
          if (count?.routers===true && typeof(count?.routersQuantity) === 'string') {tempArray.push(Number(count?.routersQuantity))}
          if (count?.rtu===true && typeof(count?.rtuQuantity) === 'string') {tempArray.push(Number(count?.rtuQuantity))}
          if (count?.safetyController===true && typeof(count?.safetyControllerQuantity) === 'string') {tempArray.push(Number(count?.safetyControllerQuantity))}
          if (count?.vpnAsset===true && typeof(count?.vpnAssetQuantity) === 'string') {tempArray.push(Number(count?.vpnAssetQuantity))}
          if (count?.workstations===true && typeof(count?.workstationsQuantity) === 'string') {tempArray.push(Number(count?.workstationsQuantity))}
          // let tempArray = [ Number(count?.applicationServerQuantity), Number(count?.dataGatewayQuantity), Number(count?.dataHistorianQuantity), Number(count?.fieldioQuantity), Number(count?.hmiQuantity), Number(count?.iedQuantity), Number(count?.jumpHostQuantity), Number(count?.plcQuantity), Number(count?.routersQuantity), Number(count?.rtuQuantity), Number(count?.safetyControllerQuantity), Number(count?.vpnAssetQuantity), Number(count?.workstationsQuantity)];
          let totalCount = tempArray.reduce((acc, value) => {
              return typeof value === 'number' ? acc + value : acc;
            }, 0);
          console.log(totalCount);
          let tempTotalZoneScore = 0;
          let tempZoneScore = 0;
          let tempList = [];
          for (let technique in allTechniques) {
            let tempScore = 0;
            let id = getId();
            const getScore = (qnty) => {
              // console.log((((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.applicationServerQuantity) / totalCount).toFixed(2));
              // console.log(typeof((((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.applicationServerQuantity) / totalCount).toFixed(2)));
              tempTotalZoneScore = tempTotalZoneScore + 1;
              // console.log(qnty);
              tempZoneScore = tempZoneScore + Number((((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*qnty) / totalCount))
              console.log(allTechniques[technique])
              console.log(allZoneData[zone][allTechniques[technique]]);

              tempScore = tempScore + Number((((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*qnty) / totalCount))
              return (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*qnty) / totalCount).toFixed(2)
            }
            tempList.push(
              {
                _id: id,
                technique: allTechniques[technique],
                applicationServer: (count.applicationServer===true && techniquesPerAsset2.applicationServer.includes(allTechniques[technique]) && getScore(count.applicationServerQuantity) || ''),
                controlServer: (count.controlServer===true && techniquesPerAsset2.controlServer.includes(allTechniques[technique]) && getScore(count.controlServerQuantity) || ''),
                dataGateway: (count.dataGateway===true && techniquesPerAsset2.dataGateway.includes(allTechniques[technique]) && getScore(count.dataGatewayQuantity) || ''),
                dataHistorian: (count.dataHistorian===true && techniquesPerAsset2.dataHistorian.includes(allTechniques[technique]) && getScore(count.dataHistorianQuantity) || ''),
                fieldio: (count.fieldio===true && techniquesPerAsset2.fieldio.includes(allTechniques[technique]) && getScore(count.fieldioQuantity) || ''),
                hmi: (count.hmi===true && techniquesPerAsset2.hmi.includes(allTechniques[technique]) && getScore(count.hmiQuantity) || ''),
                ied: (count.ied===true && techniquesPerAsset2.ied.includes(allTechniques[technique]) && getScore(count.iedQuantity) || ''),
                jumpHost:(count.jumpHost===true && techniquesPerAsset2.jumpHost.includes(allTechniques[technique]) && getScore(count.jumpHostQuantity) || ''),
                plc: (count.plc===true && techniquesPerAsset2.plc.includes(allTechniques[technique]) && getScore(count.plcQuantity) || ''),
                routers: (count.routers===true && techniquesPerAsset2.routers.includes(allTechniques[technique]) && getScore(count.routersQuantity) || ''),
                rtu: (count.rtu===true && techniquesPerAsset2.rtu.includes(allTechniques[technique]) && getScore(count.rtuQuantity) || ''),
                safetyController: (count.safetyController===true && techniquesPerAsset2.safetyController.includes(allTechniques[technique]) && getScore(count.safetyControllerQuantity) || ''),
                vpnAsset: (count.vpnAsset===true && techniquesPerAsset2.vpnAsset.includes(allTechniques[technique]) && getScore(count.vpnAssetQuantity) || ''),
                workstations: (count.workstations===true && techniquesPerAsset2.workstations.includes(allTechniques[technique]) && getScore(count.workstationsQuantity) || ''),
                score: tempScore.toFixed(2)
              },
            )
            // tempList.push(
            //   {
            //     _id: id,
            //     technique: allTechniques[technique],
            //     applicationServer: (count.applicationServer===true && techniquesPerAsset2.applicationServer.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.applicationServerQuantity) / totalCount).toFixed(2) || ''),
            //     controlServer: (count.controlServer===true && techniquesPerAsset2.controlServer.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.controlServerQuantity)  / totalCount).toFixed(2) || ''),
            //     dataGateway: (count.dataGateway===true && techniquesPerAsset2.dataGateway.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.dataGatewayQuantity)/totalCount).toFixed(2) || ''),
            //     dataHistorian: (count.dataHistorian===true && techniquesPerAsset2.dataHistorian.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.dataHistorianQuantity) / totalCount).toFixed(2) || ''),
            //     fieldio: (count.fieldio===true && techniquesPerAsset2.fieldio.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.fieldioQuantity) / totalCount).toFixed(2) || ''),
            //     hmi: (count.hmi===true && techniquesPerAsset2.hmi.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.hmiQuantity) / totalCount).toFixed(2) || ''),
            //     ied: (count.ied===true && techniquesPerAsset2.ied.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.iedQuantity) / totalCount).toFixed(2) || ''),
            //     jumpHost:(count.jumpHost===true && techniquesPerAsset2.jumpHost.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.jumpHostQuantity) / totalCount).toFixed(2) || ''),
            //     plc: (count.plc===true && techniquesPerAsset2.plc.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.plcQuantity) / totalCount).toFixed(2) || ''),
            //     routers: (count.routers===true && techniquesPerAsset2.routers.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.routersQuantity) / totalCount).toFixed(2) || ''),
            //     rtu: (count.rtu===true && techniquesPerAsset2.rtu.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.rtuQuantity) / totalCount).toFixed(2) || ''),
            //     safetyController: (count.safetyController===true && techniquesPerAsset2.safetyController.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.safetyControllerQuantity) / totalCount).toFixed(2) || ''),
            //     vpnAsset: (count.vpnAsset===true && techniquesPerAsset2.vpnAsset.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.vpnAssetQuantity) / totalCount).toFixed(2) || ''),
            //     workstations: (count.workstations===true && techniquesPerAsset2.workstations.includes(allTechniques[technique]) && (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*count.workstationsQuantity) / totalCount).toFixed(2) || ''),
            //     score: tempScore
            //   },
            // )
          }
          let filteredList = tempList.filter(score => score.score !== "0.00");
          console.log(filteredList);
          setTotalZoneAttackSurface(tempTotalZoneScore);
          setColumns(tempColumns);
          setRows(filteredList);
          setZoneScore(tempZoneScore);
        }
      }
});

const handleOpenInstructions = () => {
  setOpenInstructions(!openInstructions);
};

const techniqueDescriptions = ['Activate Firmware - Update Mode	Adversaries may activate firmware update mode on devices to prevent expected response functions from engaging in reaction to an emergency or process malfunction. For example, devices such as protection relays may have an operation mode designed for firmware installation. This mode may halt process monitoring and related functions to allow new firmware to be loaded. A device left in update mode may be placed in an inactive holding state if no firmware is provided to it. By entering and leaving a device in this mode, the adversary may deny its usual functionalities.',
];

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 1000,
  },
});

const handleScreenWidgets = () => {
  if (screenWidgets === 6) {
    setScreenWidgets(10);
  }
  if (screenWidgets === 10) {
    setScreenWidgets(6);
  }
}

 // Columns for MUI Data Grid
  // const columns = [
  //   {
  //       field: "technique",
  //       headerName: "Attack Technique",
  //       flex: 3,
  //       renderCell: (params) =>  (
  //      <CustomWidthTooltip title={<p style={{ fontSize: "20px" }}>{techniqueDescriptions[0]}</p>} >
  //       <span>{params.value}</span>
  //       </CustomWidthTooltip>
  //       )
  //   },
  //   {
  //       field: "applicationServer",
  //       headerName: "Application Server",
  //       flex: 2,
  //   },
  //   {
  //       field: "controlServer",
  //       headerName: "Control Server",
  //       flex: 2,
  //   },
  //   {
  //       field: "dataGateway",
  //       headerName: "Data Gateway",
  //       flex: 2,
  //   },
  //      {
  //       field: "dataHistorian",
  //       headerName: "dataHistorian",
  //       flex: 2,
  //   },
  //   {
  //       field: "fieldio",
  //       headerName: "fieldio",
  //       flex: 2,
  //   },
  //   {
  //       field: "hmi",
  //       headerName: "hmi",
  //       flex: 2,
  //   },
  //   {
  //       field: "ied",
  //       headerName: "ied",
  //       flex: 2,
  //   },
  //   {
  //       field: "jumpHost",
  //       headerName: "jumpHost",
  //       flex: 2,
  //   },
  //   {
  //       field: "plc",
  //       headerName: "plc",
  //       flex: 2,
  //   },
  //   {
  //       field: "routers",
  //       headerName: "routers",
  //       flex: 2,
  //   },
  //          {
  //       field: "rtu",
  //       headerName: "rtu",
  //       flex: 2,
  //   },
  //   {
  //       field: "safetyController",
  //       headerName: "safetyController",
  //       flex: 2,
  //   },
  //   {
  //       field: "vpnAsset",
  //       headerName: "VPN",
  //       flex: 2,
  //   },
  //   {
  //       field: "workstations",
  //       headerName: "workstations",
  //       flex: 2,
  //   },
    
  // ];


  return (
    <NodeContext.Provider value = {[ nodes, setNodes ]}>
    <Box>

        {/**INSTRUCTION BLOCK */}
        <Grid container spacing={0} sx={{ mb:'1rem' }}>
        <Grid item xs={12} >
        <Paper sx={{ backgroundImage: "none", backgroundColor: theme.palette.background.alt, borderRadius: "0.55rem", mr:'0.55rem', p:'4px'}} >
          <Grid item xs={12} sx={{ p:'0.5rem' }}>
          {openInstructions ? (
            <IconButton color="primary"  aria-label="open or close instructions" onClick={handleOpenInstructions} >
              <ExpandCircleDownIcon sx={{ transform: 'rotate(180deg)'}} color='primary' fontSize="large" />
              <Typography variant='h3' sx={{ ml: '1.5rem' }}><u>Instructions</u>:</Typography>
            </IconButton>
            ) : (
            <IconButton color="primary"  aria-label="open or close detection and response" onClick={handleOpenInstructions} >
              <ExpandCircleDownIcon color='primary' fontSize="large" />
              <Typography variant='h3' sx={{ ml: '1.5rem' }}>Instructions</Typography>
            </IconButton>
            )}
            <Divider sx={{ border:0.5, mt:'6px' }}/>
          </Grid>
          <Collapse in={openInstructions} timeout="auto" unmountOnExit>
            <Grid container spacing={1}>
              <Grid item xs={12} sx={{ ml:'2rem' }}>
                <Typography>1. Double-click on a Zone in the diagram on the right-side of the screen.</Typography>
                <Typography>2. Review the scores on the left side of the screen for each Zone.</Typography>
                <Typography>3. You can download the scores for each Zone and the image separately.  If you need to add or make changes to a Zone go back to the 'Define Zones' page.</Typography>
                <Typography display='inline'><u>Note</u>:  </Typography>
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      </Grid>
     </Grid>

      <Dialog
        open={openSaveAs}
        onClose={handleNo}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
        {"Save as..."}
        </DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
            Save as... <Input onChange={(e) => {setAttackTreeName(e.target.value)}} />
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleSaveAs}>Save</Button>
        <Button onClick={handleNoSaveAs}>
            Cancel
        </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleNo}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
        {"New File..."}
        </DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
            Filename... <Input onChange={(e) => {setAttackTreeName(e.target.value)}}/>
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        {/* <Button onClick={handleYes}>Save</Button> */}
        <Button onClick={onStore}>Save</Button>
        <Button onClick={handleNo}>
            Cancel
        </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openToDelete}
        onClose={handleNo}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
        {"Delete AttackTree"}
        </DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete {attackTreeName}?
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleDeleteAttackTree}>Yes</Button>
        <Button onClick={handleNo} autoFocus>
            Cancel
        </Button>
        </DialogActions>
      </Dialog>
     
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WidgetWrapper>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant= 'h2'>{displayNode || "Select a Zone"}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant= 'h3'>Raw Score:  {zoneScore?.toFixed(2)}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant= 'h3'>Protection Score:  {((zoneScore / (rows?.length))*100).toFixed(2) || "0"}% </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant= 'h3'>Total Attack Surface:  {totalZoneAttackSurface}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant= 'h3'>Exposed Attack Surface:  {((totalZoneAttackSurface-zoneScore)?.toFixed(2)) || ""}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
            </WidgetWrapper>
          </Grid>

 
          <Grid item xs={screenWidgets} >
            <ReactFlowProvider>
        <div style={{ flexDirection: 'column', display: 'flex', flexGrow: '1', height: '80vh' }} ref={reactFlowWrapper}>  
          <ReactFlow
            ref={ref}
            nodes={nodes}
            onNodesChange={onNodesChange}
            onNodeContextMenu={onNodeContextMenu}
            onSelectionContextMenu={onSelectedContextMenu}
            onNodeClick={onNodeClick}
            // onNodeDoubleClick={onNodeClick}
            edges={edges}
            onEdgesChange={onEdgesChange}
            onEdgeUpdate={onEdgeUpdate}
            onPaneClick={onPaneClick}
            defaultViewport={defaultViewport}
            fitView
            minZoom={0.5}
            maxZoom={2}
            onConnect={onConnect}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            connectionLineComponent={FloatingConnectionLine}
            onInit={setReactFlowInstance}
            onDrop={onDrop}
            onDragOver={onDragOver}
            onNodeDragStart={onNodeDragStart}
            onNodeDrag={onNodeDrag}
            onNodeDragStop={onNodeDragStop}
            deleteKeyCode={['Backspace', 'Delete']}
            style={rfStyle}
            >
            {menu && <ContextMenu onClick={onPaneClick} {...menu} />}
            <MiniMap style={minimapStyle} zoomable pannable 
              nodeColor={(n) => { 
                if (n.type ==='resizableNodeSelected') return 'grey';
                if (n.type === 'resizableObjective') return '#e5b80B';
                if (n.type === 'resizableAttackVector') return '#ff0000';
                if (n.type === 'group') return '#1390BB';
              }}
            />
            <Background gap={22} size={2} />
            <Controls />  
            <Panel position='top-center' style={{ display:'flex', justifyContent:'flex', background: palette.background.default, width:'auto', minWidth:'200px', border: 'solid 1px', padding: '5px', margin: 'auto' }}>
              {/* <Button sx={{ ml: '1rem', mr: '1rem', width: 'auto' }} variant="contained" onClick={() => {setOpen(true)}}>New</Button>
              <Button sx={{ mr: '1rem', width: 'auto' }} variant="contained" onClick={onSave}>Save</Button>  
              <Button sx={{ mr: '1rem', width: 'auto' }} variant="contained" onClick={() => {setOpenSaveAs(true)}}>
                Save As
              </Button>
              <Button sx={{marginRight: '1rem'}} variant='contained' onClick={() => {handleClickOpen()}}>Delete</Button> */}
              <IconButton color="primary"  aria-label="expand zone drawing pad" onClick={handleScreenWidgets} sx={{ mr: '10px' }}>
                <LaunchIcon fontSize='large' />
              </IconButton>
              <DownloadButton />
              {/* <FormControl  sx={{ minWidth: '200px' }} >
                <InputLabel sx={{ mt: '5px' }} id="demo-simple-select-label">Open Attack Tree</InputLabel>
                <Select
                  // sx={{ color: 'black' }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={attackTreeName}
                  label="Open Attack Tree"
                  onChange={handleChange}
                  // onChange={onRestore}
                >
                  {allAssessmentAttackTrees.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                    >
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Panel>
          </ReactFlow>
        </div>
        </ReactFlowProvider>
        </Grid>

      {screenWidgets === 10 && (
         <Grid item xs={2}>
          <Sidebar />
        </Grid>
      )}
       

      {/** DATA GRID OF CYBER ASSETS */}
      <Grid item xs={screenWidgets}>
        <Grid container spacing={1}>
          
            <Grid item xs={12} >
              <Box
                sx={{
                mt:'0.5rem', flexGrow: 1, backgroundColor: theme.palette.background.alt, borderRadius: "0.75rem",
                  height: 1000,
                  width: '100%',
                  typography: '44pt',
                  "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: theme.palette.secondary.alt,
                      color: theme.palette.secondary[100],
                      borderBottom: "solid 2px black",
                      borderTop: "solid 2px black"
                  },
                  "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: theme.palette.primary.light,
                  },
                  "& .MuiDataGrid-footerContainer": {
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary[100],
                      borderTop: "none"
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                      color: `${theme.palette.secondary[200]} !important`,
                  },
                  [`.${gridClasses.cell}.cold`]: {
                    backgroundColor: '#3DFBA0',
                    color: '#1a3e72',
                  },
                  [`.${gridClasses.cell}.hot`]: {
                    backgroundColor: '#FC6B6B',
                    color: '#1a3e72',
                  },
                  [`.${gridClasses.cell}.yellow`]: {
                    backgroundColor: '#FBEC3D',
                    color: '#1a3e72',
                  },
                  [`.${gridClasses.cell}.orange`]: {
                    backgroundColor: '#FBA63D',
                    color: '#1a3e72',
                  },
              }}
              >
                <DataGrid
                  rows={rows || []} 
                  getRowId={(row) => row._id}
                  columns={columns}
                  editMode="row"
                  loading={!rows}
                  columnHeaderHeight={70}
                  slots={{
                    toolbar: DataGridCustomToolbar,
                  }}
                  getCellClassName={(params) => {
          //  if (params.field === 'technique') {
          //             return ""
          //           }
                      if (params.field === 'score' && params.value > 0) {
                        return params.value < 0.25 ? 'hot' : 
                          params.value < 0.5 ? 'orange' : 
                          params.value < 0.75 ? 'yellow' : 'cold' ;
                      }
                      
                    }}
        
                  // rowModesModel={rowModesModel}
                  // onRowModesModelChange={handleRowModesModelChange}
                  // onRowEditStop={handleRowEditStop}
                  // processRowUpdate={processRowUpdate}
                  // sx={{ fontSize: "1.25em" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      
    </Box>
    </NodeContext.Provider>
  )
}

export default ZoneCreator;